import styled from 'styled-components';
import { TimePicker } from 'antd';

// Anchor for the absolutely-positioned ErrorText. The wrapper itself has
// no height contribution beyond the input row it contains — so this column
// stays the same size as the label / date / From columns and the outer
// row's align="center" produces a single stable input baseline across all
// parts, whether or not a validation error is currently showing.
export const TimeFieldWrapper = styled.div`
  position: relative;
`;

// One-line error text pinned just below the input row. Positioned absolute
// so it doesn't grow the To column and shift the input off the row's
// centerline. The parent PartDateInput row reserves ~20px of padding-bottom
// for it to render into without colliding with the next part row.
export const ErrorText = styled.div`
  position: absolute;
  top: calc(100% + 2px);
  left: 0;
  color: #ff4d4f;
  font-size: 12px;
  line-height: 16px;
  white-space: nowrap;
`;

export const WorkshopDatePickerWrapper = styled.div`
  .ant-picker {
    border: 0 !important;
    .ant-picker-input input {
      font-weight: 400 !important;
      width: auto !important;
      min-width: 128px;
      cursor: pointer !important;
    }
  }
  &.ant-picker-disabled,
  .ant-picker.ant-picker-disabled {
    .ant-picker-input {
      input {
        color: #808080 !important;
        cursor: not-allowed !important;
      }
    }
  }
  & .ant-btn {
    min-width: 128px;
    justify-content: flex-start;
  }
`;

export const WorkshopTimePicker = styled(TimePicker)`
  &.ant-picker {
    border: 0 !important;
    background-color: transparent !important;
    box-shadow: none !important;
    padding: 0 !important;

    .ant-picker-input {
      input {
        font-weight: 400 !important;
        cursor: pointer !important;
        text-align: left !important;
        padding: 0 !important;
        min-width: 120px;
      }
    }

    .ant-picker-suffix {
      display: none !important; /* Hides the clock icon */
    }

    .ant-picker-clear {
      display: none !important; /* Hides the clear/close button */
    }
  }

  &.ant-picker-disabled {
    .ant-picker-input {
      input {
        color: #808080 !important;
        cursor: not-allowed !important; /* ensure not pointer when disabled */
      }
    }
  }

  &:hover.ant-picker {
    border: 0 !important;
    box-shadow: none !important;
  }

  &.ant-picker-focused {
    border: 0 !important;
    box-shadow: none !important;
  }
`;
